import { useDispatch, useSelector } from 'react-redux'
import { userSlice } from '../../slices/userSlice'
import { useCallback } from 'react'
import { reselectUser } from '@wellesley/host-remote/api/actions'
import { AppDispatch } from '@wellesley/store'

export const useChangeUser = () => {
  const selectedUserId = useSelector(userSlice.selectors.selectSelectedUserId)
  const dispatch = useDispatch<AppDispatch>()

  const changeUser = useCallback(
    (nextUserId: string) => {
      if (selectedUserId !== nextUserId) {
        void dispatch(reselectUser({ userId: nextUserId }))
      }
    },
    [selectedUserId, dispatch],
  )

  return { changeUser, selectedUserId }
}
